import { createFileRoute } from '@tanstack/react-router';
import { ensureOBSPresence } from '../../utils/ensureOBSPresence';
import { CompositionsService } from '../../services/CompositionsService';
import { CanvasNotFound } from '../_authenticated.canvases/$canvasId/-errors/CanvasNotFound';
import { streamDestinationsQueryOptions } from '../../api/streamDestinations';
import { Destination } from '../../services/DestinationsApiClient';
import { promisefy } from '../../utils/promisefy';
import { AudioCompositionsService } from '../../services/AudioCompositionsService';

export const Route = createFileRoute('/_authenticated/settings/_layout/$canvasId/')({
  component: () => <div></div>,
  errorComponent: CanvasNotFound,
  loader: async ({ params, context: { authContextProvider, serviceEnvironment, queryClient } }) => {
    await ensureOBSPresence();

    const videoCompositionsList = await CompositionsService.getActiveCompositions();

    if (!videoCompositionsList[params.canvasId]) {
      throw new Error('Video composition not found');
    }

    const allRecodingOutputs = await promisefy(window.host.getAllRecordingOutputs)();

    const canvases = [];

    for (const id of Object.keys(videoCompositionsList).filter(i => i !== 'default')) {
      const recordingSettings = await AudioCompositionsService.getRecordingSettings({
        audioCompositionId: id,
      });

      const recordingOutput = allRecodingOutputs[id];

      const destinations: Map<string, Destination> = await queryClient.fetchQuery(
        streamDestinationsQueryOptions({
          authContextProvider,
          serviceEnvironment,
        })
      );

      const filteredDestinations = Array.from(destinations.values()).filter((destination) =>
        destination.outputs.some((output) => output.videoCompositionId === id)
      );

      const videoComposition = videoCompositionsList[id];
      const videoCompositionTransitionSettings = await CompositionsService.getTransitionSettings(videoComposition.id);

      const canvas = {
        recordingOutput,
        videoComposition,
        videoCompositionTransitionSettings,
        recordingSettings,
        videoCompositionsList,
        destinations: filteredDestinations,
      };

      canvases.push(canvas);
    }

    return {
      canvasId: params.canvasId,
      canvases,
    };
  },
});
